// --  导入管理  import
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
import EmptyRouter from '@/layout/EmptyRouter.vue';
export default {
  path: 'import',
  name: 'BusinessImport',
  component: EmptyRouterAlive,
  meta: {
    title: '导入管理',
  },
  children: [
    {
      path: 'history',
      name: 'BusinessImportHistory',
      component: EmptyRouter,
      redirect: 'history/index',
      meta: {
        title: '导入历史',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessImportHistoryIndex',
          component: () => import('@/views/center-business/import/history/index'),
          meta: {
            title: '导入历史列表',
          },
        },
      ],
    },
    {
      path: 'general',
      name: 'BusinessImportGeneral',
      component: EmptyRouter,
      redirect: 'general/index',
      meta: {
        title: '通用导入管理',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessImportGeneralIndex',
          component: () => import('@/views/center-business/import/general/index'),
          meta: {
            title: '通用导入列表',
            isCache: true
          },
        },
        {
          path: 'add',
          name: 'BusinessImportGeneralAdd',
          component: () => import('@/views/center-business/import/general/add'),
          meta: {
            title: '新增通用模板',
          },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'BusinessImportGeneralEdit',
          component: () => import('@/views/center-business/import/general/edit'),
          meta: {
            title: '编辑通用模板',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessImportGeneralIndex_Delete',
          meta: {
            title: '删除通用模板',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessImportGeneralIndex_Export',
          meta: {
            title: '导出通用模板',
          },
          hidden: true,
        },
        {
          path: 'column',
          name: 'BusinessImportGeneralColumn',
          component: () => import('@/views/center-business/import/general/column'),
          meta: {
            title: '模板列',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessImportGeneralColumn_Add',
          meta: {
            title: '新增模板列',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessImportGeneralColumn_Edit',
          meta: {
            title: '编辑模板列',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessImportGeneralColumn_Delete',
          meta: {
            title: '删除模板列',
          },
          hidden: true,
        },
      ],
    },
  ],
};
